
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export const EventLoadingState = () => {
  return (
    <div className="min-h-screen bg-black flex flex-col">
      <Header />
      <main className="flex-grow container mx-auto px-4 pt-24">
        <div className="flex items-center justify-center h-full">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-white"></div>
        </div>
      </main>
      <Footer />
    </div>
  );
};
